import { MainCalculator } from "../components/MainCalculator";
import { SubCalculators } from "../components/SubCalculators";
import { AdSlot } from "../components/AdSlot";
import { useSeo } from "../lib/useSeo";

export const CalculatorsPage = () => {
    useSeo({
        title: "All Hydration Calculators",
        description:
            "Every hydration calculator in one place — daily water intake, workout fluids, pregnancy, kids and elderly, plus a unit converter (oz, ml, L, cups).",
        path: "/calculators",
    });

    return (
        <>
            <section className="border-b border-foreground py-12 sm:py-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
                    <div className="editorial-label mb-3">The full toolkit</div>
                    <h1 className="text-5xl sm:text-7xl font-black tracking-tighter uppercase leading-none mb-4">
                        Calculators.
                    </h1>
                    <p className="text-lg text-foreground/70 max-w-2xl">
                        Every hydration calculator we offer in one place — daily intake, workout
                        fluids, pregnancy, kids, elderly, and a unit converter.
                    </p>
                </div>
            </section>

            <section className="py-12 sm:py-16">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
                    <h2 className="text-3xl sm:text-4xl font-black tracking-tighter mb-8">
                        01 Daily intake
                    </h2>
                    <MainCalculator />
                </div>
            </section>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
                <AdSlot slot="calculators-mid" height={120} testId="ad-calc-mid" />
            </div>

            <section className="py-12 sm:py-16 border-t border-foreground">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
                    <h2 className="text-3xl sm:text-4xl font-black tracking-tighter mb-8">
                        02 Specialty calculators
                    </h2>
                    <SubCalculators />
                </div>
            </section>
        </>
    );
};
